import { ImportCsvFile } from "./importCsvFileTypes"

export function createImportCsvFormData(importData: ImportCsvFile) {
    const { file, updateMatching, deleteUnmatched } = importData
    const formData = new FormData()
    formData.append("file", file)
    formData.append("updateMatching", updateMatching ? "1" : "0")
    formData.append("deleteUnmatched", deleteUnmatched ? "1" : "0")

    return formData
}
